<template>

    <div class="min-h-screen flex flex-col">

        <navbar></navbar>

        Meet our chasers...

        <page-footer></page-footer>

    </div>
</template>

<script>

    import * as Config from '../config'

    import VideoOnDemandPlayer from '@/components/VideoOnDemandPlayer'
    import Navbar from '@/components/Navbar'
    import PageFooter from '@/components/PageFooter'
    import { Carousel, Slide } from 'vue-carousel';
    import Gravatar from 'vue-gravatar';

    export default {
        name: 'home',
        components: {
            VideoOnDemandPlayer,
            PageFooter,
            Carousel,
            Slide,
            Gravatar,
            Navbar
        },
        data() {
            return {
                randomChasers: []
            }
        },
        mounted() {
            this.getRandomChasers()
        },
        methods: {
            getRandomChasers() {
                this.$http.get(Config.apiPath + "/api/v1/chasers/random?limit=10").then((response) => {
                    this.$set(this, 'randomChasers', response.data);
                });
            }
        },
    }

</script>
